// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const AMAZON_BEDROCK_MODELS = {
	"amazon.nova-2-lite-v1:0": {
		id: "amazon.nova-2-lite-v1:0",
		name: "Nova 2 Lite",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.33,
			output: 2.75,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"amazon.nova-lite-v1:0": {
		id: "amazon.nova-lite-v1:0",
		name: "Nova Lite",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.06,
			output: 0.24,
			cacheRead: 0.015,
			cacheWrite: 0,
		},
		contextWindow: 300000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"amazon.nova-micro-v1:0": {
		id: "amazon.nova-micro-v1:0",
		name: "Nova Micro",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.035,
			output: 0.14,
			cacheRead: 0.00875,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"amazon.nova-pro-v1:0": {
		id: "amazon.nova-pro-v1:0",
		name: "Nova Pro",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.8,
			output: 3.2,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 300000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-fable-5": {
		id: "anthropic.claude-fable-5",
		name: "Claude Fable 5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 50,
			cacheRead: 1,
			cacheWrite: 12.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-haiku-4-5-20251001-v1:0": {
		id: "anthropic.claude-haiku-4-5-20251001-v1:0",
		name: "Claude Haiku 4.5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-opus-4-1-20250805-v1:0": {
		id: "anthropic.claude-opus-4-1-20250805-v1:0",
		name: "Claude Opus 4.1",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 75,
			cacheRead: 1.5,
			cacheWrite: 18.75,
		},
		contextWindow: 200000,
		maxTokens: 32000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-opus-4-5-20251101-v1:0": {
		id: "anthropic.claude-opus-4-5-20251101-v1:0",
		name: "Claude Opus 4.5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-opus-4-6-v1": {
		id: "anthropic.claude-opus-4-6-v1",
		name: "Claude Opus 4.6",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-opus-4-7": {
		id: "anthropic.claude-opus-4-7",
		name: "Claude Opus 4.7",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-opus-4-8": {
		id: "anthropic.claude-opus-4-8",
		name: "Claude Opus 4.8",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-sonnet-4-5-20250929-v1:0": {
		id: "anthropic.claude-sonnet-4-5-20250929-v1:0",
		name: "Claude Sonnet 4.5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-sonnet-4-6": {
		id: "anthropic.claude-sonnet-4-6",
		name: "Claude Sonnet 4.6",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"anthropic.claude-sonnet-5": {
		id: "anthropic.claude-sonnet-5",
		name: "Claude Sonnet 5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 10,
			cacheRead: 0.2,
			cacheWrite: 2.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"au.anthropic.claude-haiku-4-5-20251001-v1:0": {
		id: "au.anthropic.claude-haiku-4-5-20251001-v1:0",
		name: "Claude Haiku 4.5 (AU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"au.anthropic.claude-opus-4-6-v1": {
		id: "au.anthropic.claude-opus-4-6-v1",
		name: "AU Anthropic Claude Opus 4.6",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 16.5,
			output: 82.5,
			cacheRead: 1.65,
			cacheWrite: 20.625,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"au.anthropic.claude-opus-4-8": {
		id: "au.anthropic.claude-opus-4-8",
		name: "Claude Opus 4.8 (AU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"au.anthropic.claude-sonnet-4-5-20250929-v1:0": {
		id: "au.anthropic.claude-sonnet-4-5-20250929-v1:0",
		name: "Claude Sonnet 4.5 (AU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"au.anthropic.claude-sonnet-4-6": {
		id: "au.anthropic.claude-sonnet-4-6",
		name: "AU Anthropic Claude Sonnet 4.6",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3.3,
			output: 16.5,
			cacheRead: 0.33,
			cacheWrite: 4.125,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"au.anthropic.claude-sonnet-5": {
		id: "au.anthropic.claude-sonnet-5",
		name: "Claude Sonnet 5 (AU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 10,
			cacheRead: 0.2,
			cacheWrite: 2.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"deepseek.r1-v1:0": {
		id: "deepseek.r1-v1:0",
		name: "DeepSeek-R1",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.35,
			output: 5.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 32768,
	} satisfies Model<"bedrock-converse-stream">,
	"deepseek.v3-v1:0": {
		id: "deepseek.v3-v1:0",
		name: "DeepSeek-V3.1",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.58,
			output: 1.68,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 163840,
		maxTokens: 81920,
	} satisfies Model<"bedrock-converse-stream">,
	"deepseek.v3.2": {
		id: "deepseek.v3.2",
		name: "DeepSeek-V3.2",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.62,
			output: 1.85,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 163840,
		maxTokens: 81920,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-fable-5": {
		id: "eu.anthropic.claude-fable-5",
		name: "Claude Fable 5 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 11,
			output: 55,
			cacheRead: 1.1,
			cacheWrite: 13.75,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-haiku-4-5-20251001-v1:0": {
		id: "eu.anthropic.claude-haiku-4-5-20251001-v1:0",
		name: "Claude Haiku 4.5 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.1,
			output: 5.5,
			cacheRead: 0.11,
			cacheWrite: 1.375,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-opus-4-5-20251101-v1:0": {
		id: "eu.anthropic.claude-opus-4-5-20251101-v1:0",
		name: "Claude Opus 4.5 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 5.5,
			output: 27.5,
			cacheRead: 0.55,
			cacheWrite: 6.875,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-opus-4-6-v1": {
		id: "eu.anthropic.claude-opus-4-6-v1",
		name: "Claude Opus 4.6 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5.5,
			output: 27.5,
			cacheRead: 0.55,
			cacheWrite: 6.875,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-opus-4-7": {
		id: "eu.anthropic.claude-opus-4-7",
		name: "Claude Opus 4.7 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5.5,
			output: 27.5,
			cacheRead: 0.55,
			cacheWrite: 6.875,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-opus-4-8": {
		id: "eu.anthropic.claude-opus-4-8",
		name: "Claude Opus 4.8 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5.5,
			output: 27.5,
			cacheRead: 0.55,
			cacheWrite: 6.875,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-sonnet-4-5-20250929-v1:0": {
		id: "eu.anthropic.claude-sonnet-4-5-20250929-v1:0",
		name: "Claude Sonnet 4.5 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3.3,
			output: 16.5,
			cacheRead: 0.33,
			cacheWrite: 4.125,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-sonnet-4-6": {
		id: "eu.anthropic.claude-sonnet-4-6",
		name: "Claude Sonnet 4.6 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3.3,
			output: 16.5,
			cacheRead: 0.33,
			cacheWrite: 4.125,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"eu.anthropic.claude-sonnet-5": {
		id: "eu.anthropic.claude-sonnet-5",
		name: "Claude Sonnet 5 (EU)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.eu-central-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2.2,
			output: 11,
			cacheRead: 0.22,
			cacheWrite: 2.75,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-fable-5": {
		id: "global.anthropic.claude-fable-5",
		name: "Claude Fable 5 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 50,
			cacheRead: 1,
			cacheWrite: 12.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-haiku-4-5-20251001-v1:0": {
		id: "global.anthropic.claude-haiku-4-5-20251001-v1:0",
		name: "Claude Haiku 4.5 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-opus-4-5-20251101-v1:0": {
		id: "global.anthropic.claude-opus-4-5-20251101-v1:0",
		name: "Claude Opus 4.5 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-opus-4-6-v1": {
		id: "global.anthropic.claude-opus-4-6-v1",
		name: "Claude Opus 4.6 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-opus-4-7": {
		id: "global.anthropic.claude-opus-4-7",
		name: "Claude Opus 4.7 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-opus-4-8": {
		id: "global.anthropic.claude-opus-4-8",
		name: "Claude Opus 4.8 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-sonnet-4-5-20250929-v1:0": {
		id: "global.anthropic.claude-sonnet-4-5-20250929-v1:0",
		name: "Claude Sonnet 4.5 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-sonnet-4-6": {
		id: "global.anthropic.claude-sonnet-4-6",
		name: "Claude Sonnet 4.6 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"global.anthropic.claude-sonnet-5": {
		id: "global.anthropic.claude-sonnet-5",
		name: "Claude Sonnet 5 (Global)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 10,
			cacheRead: 0.2,
			cacheWrite: 2.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"google.gemma-3-27b-it": {
		id: "google.gemma-3-27b-it",
		name: "Google Gemma 3 27B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.12,
			output: 0.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"google.gemma-3-4b-it": {
		id: "google.gemma-3-4b-it",
		name: "Gemma 3 4B IT",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.04,
			output: 0.08,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"jp.anthropic.claude-haiku-4-5-20251001-v1:0": {
		id: "jp.anthropic.claude-haiku-4-5-20251001-v1:0",
		name: "Claude Haiku 4.5 (JP)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"jp.anthropic.claude-opus-4-7": {
		id: "jp.anthropic.claude-opus-4-7",
		name: "Claude Opus 4.7 (JP)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"jp.anthropic.claude-opus-4-8": {
		id: "jp.anthropic.claude-opus-4-8",
		name: "Claude Opus 4.8 (JP)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"jp.anthropic.claude-sonnet-4-5-20250929-v1:0": {
		id: "jp.anthropic.claude-sonnet-4-5-20250929-v1:0",
		name: "Claude Sonnet 4.5 (JP)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"jp.anthropic.claude-sonnet-4-6": {
		id: "jp.anthropic.claude-sonnet-4-6",
		name: "Claude Sonnet 4.6 (JP)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"jp.anthropic.claude-sonnet-5": {
		id: "jp.anthropic.claude-sonnet-5",
		name: "Claude Sonnet 5 (JP)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 10,
			cacheRead: 0.2,
			cacheWrite: 2.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"meta.llama3-1-70b-instruct-v1:0": {
		id: "meta.llama3-1-70b-instruct-v1:0",
		name: "Llama 3.1 70B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.72,
			output: 0.72,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"meta.llama3-1-8b-instruct-v1:0": {
		id: "meta.llama3-1-8b-instruct-v1:0",
		name: "Llama 3.1 8B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.22,
			output: 0.22,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"meta.llama3-3-70b-instruct-v1:0": {
		id: "meta.llama3-3-70b-instruct-v1:0",
		name: "Llama 3.3 70B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.72,
			output: 0.72,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"meta.llama4-maverick-17b-instruct-v1:0": {
		id: "meta.llama4-maverick-17b-instruct-v1:0",
		name: "Llama 4 Maverick 17B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.24,
			output: 0.97,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"meta.llama4-scout-17b-instruct-v1:0": {
		id: "meta.llama4-scout-17b-instruct-v1:0",
		name: "Llama 4 Scout 17B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.17,
			output: 0.66,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 3500000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"minimax.minimax-m2": {
		id: "minimax.minimax-m2",
		name: "MiniMax M2",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 204608,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"minimax.minimax-m2.1": {
		id: "minimax.minimax-m2.1",
		name: "MiniMax M2.1",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"bedrock-converse-stream">,
	"minimax.minimax-m2.5": {
		id: "minimax.minimax-m2.5",
		name: "MiniMax M2.5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 196608,
		maxTokens: 98304,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.devstral-2-123b": {
		id: "mistral.devstral-2-123b",
		name: "Devstral 2 123B",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.4,
			output: 2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.magistral-small-2509": {
		id: "mistral.magistral-small-2509",
		name: "Magistral Small 1.2",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 40000,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.ministral-3-14b-instruct": {
		id: "mistral.ministral-3-14b-instruct",
		name: "Ministral 14B 3.0",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.2,
			output: 0.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.ministral-3-3b-instruct": {
		id: "mistral.ministral-3-3b-instruct",
		name: "Ministral 3 3B",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.1,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.ministral-3-8b-instruct": {
		id: "mistral.ministral-3-8b-instruct",
		name: "Ministral 3 8B",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.mistral-large-3-675b-instruct": {
		id: "mistral.mistral-large-3-675b-instruct",
		name: "Mistral Large 3",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.pixtral-large-2502-v1:0": {
		id: "mistral.pixtral-large-2502-v1:0",
		name: "Pixtral Large (25.02)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.voxtral-mini-3b-2507": {
		id: "mistral.voxtral-mini-3b-2507",
		name: "Voxtral Mini 3B 2507",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.04,
			output: 0.04,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"mistral.voxtral-small-24b-2507": {
		id: "mistral.voxtral-small-24b-2507",
		name: "Voxtral Small 24B 2507",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.35,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 32000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"moonshot.kimi-k2-thinking": {
		id: "moonshot.kimi-k2-thinking",
		name: "Kimi K2 Thinking",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262143,
		maxTokens: 16000,
	} satisfies Model<"bedrock-converse-stream">,
	"moonshotai.kimi-k2.5": {
		id: "moonshotai.kimi-k2.5",
		name: "Kimi K2.5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262143,
		maxTokens: 16000,
	} satisfies Model<"bedrock-converse-stream">,
	"nvidia.nemotron-nano-12b-v2": {
		id: "nvidia.nemotron-nano-12b-v2",
		name: "NVIDIA Nemotron Nano 12B v2 VL BF16",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"nvidia.nemotron-nano-3-30b": {
		id: "nvidia.nemotron-nano-3-30b",
		name: "NVIDIA Nemotron Nano 3 30B",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.06,
			output: 0.24,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"nvidia.nemotron-nano-9b-v2": {
		id: "nvidia.nemotron-nano-9b-v2",
		name: "NVIDIA Nemotron Nano 9B v2",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.06,
			output: 0.23,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"bedrock-converse-stream">,
	"nvidia.nemotron-super-3-120b": {
		id: "nvidia.nemotron-super-3-120b",
		name: "NVIDIA Nemotron 3 Super 120B A12B",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.65,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-5.4": {
		id: "openai.gpt-5.4",
		name: "GPT-5.4",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 2.75,
			output: 16.5,
			cacheRead: 0.275,
			cacheWrite: 0,
		},
		contextWindow: 272000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-5.5": {
		id: "openai.gpt-5.5",
		name: "GPT-5.5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 5.5,
			output: 33,
			cacheRead: 0.55,
			cacheWrite: 0,
		},
		contextWindow: 272000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-5.6-luna": {
		id: "openai.gpt-5.6-luna",
		name: "GPT-5.6 Luna",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 6,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 272000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-5.6-sol": {
		id: "openai.gpt-5.6-sol",
		name: "GPT-5.6 Sol",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 272000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-5.6-terra": {
		id: "openai.gpt-5.6-terra",
		name: "GPT-5.6 Terra",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 15,
			cacheRead: 0.25,
			cacheWrite: 3.125,
		},
		contextWindow: 272000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-oss-120b": {
		id: "openai.gpt-oss-120b",
		name: "gpt-oss-120b",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-oss-120b-1:0": {
		id: "openai.gpt-oss-120b-1:0",
		name: "gpt-oss-120b",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-oss-20b": {
		id: "openai.gpt-oss-20b",
		name: "gpt-oss-20b",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.07,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-oss-20b-1:0": {
		id: "openai.gpt-oss-20b-1:0",
		name: "gpt-oss-20b",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.07,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-oss-safeguard-120b": {
		id: "openai.gpt-oss-safeguard-120b",
		name: "GPT OSS Safeguard 120B",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"openai.gpt-oss-safeguard-20b": {
		id: "openai.gpt-oss-safeguard-20b",
		name: "GPT OSS Safeguard 20B",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.07,
			output: 0.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"qwen.qwen3-235b-a22b-2507-v1:0": {
		id: "qwen.qwen3-235b-a22b-2507-v1:0",
		name: "Qwen3 235B A22B 2507",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.22,
			output: 0.88,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"bedrock-converse-stream">,
	"qwen.qwen3-32b-v1:0": {
		id: "qwen.qwen3-32b-v1:0",
		name: "Qwen3 32B (dense)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 16384,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"qwen.qwen3-coder-30b-a3b-v1:0": {
		id: "qwen.qwen3-coder-30b-a3b-v1:0",
		name: "Qwen3 Coder 30B A3B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"bedrock-converse-stream">,
	"qwen.qwen3-coder-480b-a35b-v1:0": {
		id: "qwen.qwen3-coder-480b-a35b-v1:0",
		name: "Qwen3 Coder 480B A35B Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.22,
			output: 1.8,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 65536,
	} satisfies Model<"bedrock-converse-stream">,
	"qwen.qwen3-coder-next": {
		id: "qwen.qwen3-coder-next",
		name: "Qwen3 Coder Next",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.22,
			output: 1.8,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 65536,
	} satisfies Model<"bedrock-converse-stream">,
	"qwen.qwen3-next-80b-a3b": {
		id: "qwen.qwen3-next-80b-a3b",
		name: "Qwen/Qwen3-Next-80B-A3B-Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.14,
			output: 1.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"bedrock-converse-stream">,
	"qwen.qwen3-vl-235b-a22b": {
		id: "qwen.qwen3-vl-235b-a22b",
		name: "Qwen/Qwen3-VL-235B-A22B-Instruct",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-fable-5": {
		id: "us.anthropic.claude-fable-5",
		name: "Claude Fable 5 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 50,
			cacheRead: 1,
			cacheWrite: 12.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-haiku-4-5-20251001-v1:0": {
		id: "us.anthropic.claude-haiku-4-5-20251001-v1:0",
		name: "Claude Haiku 4.5 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-opus-4-1-20250805-v1:0": {
		id: "us.anthropic.claude-opus-4-1-20250805-v1:0",
		name: "Claude Opus 4.1 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 75,
			cacheRead: 1.5,
			cacheWrite: 18.75,
		},
		contextWindow: 200000,
		maxTokens: 32000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-opus-4-5-20251101-v1:0": {
		id: "us.anthropic.claude-opus-4-5-20251101-v1:0",
		name: "Claude Opus 4.5 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-opus-4-6-v1": {
		id: "us.anthropic.claude-opus-4-6-v1",
		name: "Claude Opus 4.6 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-opus-4-7": {
		id: "us.anthropic.claude-opus-4-7",
		name: "Claude Opus 4.7 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-opus-4-8": {
		id: "us.anthropic.claude-opus-4-8",
		name: "Claude Opus 4.8 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-sonnet-4-5-20250929-v1:0": {
		id: "us.anthropic.claude-sonnet-4-5-20250929-v1:0",
		name: "Claude Sonnet 4.5 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-sonnet-4-6": {
		id: "us.anthropic.claude-sonnet-4-6",
		name: "Claude Sonnet 4.6 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.anthropic.claude-sonnet-5": {
		id: "us.anthropic.claude-sonnet-5",
		name: "Claude Sonnet 5 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 10,
			cacheRead: 0.2,
			cacheWrite: 2.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"bedrock-converse-stream">,
	"us.deepseek.r1-v1:0": {
		id: "us.deepseek.r1-v1:0",
		name: "DeepSeek-R1 (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.35,
			output: 5.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 32768,
	} satisfies Model<"bedrock-converse-stream">,
	"us.meta.llama4-maverick-17b-instruct-v1:0": {
		id: "us.meta.llama4-maverick-17b-instruct-v1:0",
		name: "Llama 4 Maverick 17B Instruct (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.24,
			output: 0.97,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"us.meta.llama4-scout-17b-instruct-v1:0": {
		id: "us.meta.llama4-scout-17b-instruct-v1:0",
		name: "Llama 4 Scout 17B Instruct (US)",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.17,
			output: 0.66,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 3500000,
		maxTokens: 16384,
	} satisfies Model<"bedrock-converse-stream">,
	"writer.palmyra-x4-v1:0": {
		id: "writer.palmyra-x4-v1:0",
		name: "Palmyra X4",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 2.5,
			output: 10,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 122880,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"writer.palmyra-x5-v1:0": {
		id: "writer.palmyra-x5-v1:0",
		name: "Palmyra X5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1040000,
		maxTokens: 8192,
	} satisfies Model<"bedrock-converse-stream">,
	"xai.grok-4.3": {
		id: "xai.grok-4.3",
		name: "Grok 4.3",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 131072,
	} satisfies Model<"bedrock-converse-stream">,
	"zai.glm-4.7": {
		id: "zai.glm-4.7",
		name: "GLM-4.7",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"bedrock-converse-stream">,
	"zai.glm-4.7-flash": {
		id: "zai.glm-4.7-flash",
		name: "GLM-4.7-Flash",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.07,
			output: 0.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 131072,
	} satisfies Model<"bedrock-converse-stream">,
	"zai.glm-5": {
		id: "zai.glm-5",
		name: "GLM-5",
		api: "bedrock-converse-stream",
		provider: "amazon-bedrock",
		baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1,
			output: 3.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 101376,
	} satisfies Model<"bedrock-converse-stream">,
} as const;
